var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mage:x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7248 3.52219H24.2955L16.4952 12.3993L25.6716 24.4781H18.486L12.8594 17.1517L6.42011 24.4781H2.84597L11.1899 14.9839L2.38727 3.52219H9.75443L14.842 10.2188L20.7248 3.52219ZM19.4721 22.3499H21.4513L8.67869 5.53861H6.55516L19.4721 22.3499Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.98d7b9cbeb9f4a1a701aa5d98b5ef897.svg";
export { ForwardRef as ReactComponent };